module.exports = __webpack_public_path__ + "img/Trend-Micro-Apex-One.0336085.svg";